import { Navigate, Route, Routes } from "react-router-dom";
import ScrollManager from "./components/common/ScrollManager";
import MainLayout from "./components/layout/MainLayout";
import About from "./pages/About";
import BachelorsIndia from "./pages/BachelorsIndia";
import Colleges from "./pages/Colleges";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import MastersIndia from "./pages/MastersIndia";
import MbbsAbroad from "./pages/MbbsAbroad";
import MbbsIndia from "./pages/MbbsIndia";

function App() {
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/bachelors-india" element={<BachelorsIndia />} />
          <Route path="/masters-india" element={<MastersIndia />} />
          <Route path="/mbbs-india" element={<MbbsIndia />} />
          <Route path="/mbbs-abroad" element={<MbbsAbroad />} />
          <Route path="/colleges" element={<Colleges />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
